import reportAlertIcon from '../../../assets/reportAlertIcon.png';

export default function CurriPublicSnackbarIcon() {
  return (
    <img src={reportAlertIcon} alt="" />
  );
}